import { FC } from 'react';
import { CacheProvider } from '@emotion/react';
import { ThemeProvider } from '@mui/material/styles';
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import theme from './theme';
import { WithChildren } from '../../app/helper/react18MigrationHelpers';
import useIsRtl from '../../app/hooks/useIsRtl';

// Create caches for RTL and LTR
const rtlCache = createCache({
  key: 'muirtl',
  stylisPlugins: [rtlPlugin],
});

const ltrCache = createCache({
  key: 'mui',
});

const MUIProvider: FC<WithChildren> = ({ children }) => {
  const isRtl = useIsRtl();

  return (
    <CacheProvider value={isRtl ? rtlCache : ltrCache}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </CacheProvider>
  );
};

export default MUIProvider;
